import { formatMoney } from "./format";
import type { FormatMoneyOptions } from "./format";
import type { Money, MoneyParam } from "./types";

export function isMoneyParam(value: unknown): value is MoneyParam {
  if (typeof value !== "object" || value === null) return false;
  const candidate = value as Record<string, unknown>;
  return (
    candidate.kind === "MONEY" &&
    typeof candidate.amountMinor === "number" &&
    typeof candidate.currency === "string" &&
    typeof candidate.figure === "boolean"
  );
}

export function moneyFromParam(param: MoneyParam): Money {
  return { amountMinor: param.amountMinor, currency: param.currency };
}

export function formatMoneyParam(param: MoneyParam, options?: FormatMoneyOptions): string {
  return formatMoney(moneyFromParam(param), options);
}
